import { CustomersService } from "./implementations/customers.service";

export default defineNuxtPlugin((nuxtApp) => {
  const customers = new CustomersService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      customers: customers,
    },
  };
});
